/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../StoreContext/Context';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import * as Yup from 'yup';
import MaskedInput from 'react-text-mask';

import { useHistory, useParams } from 'react-router-dom';
// import './styles.css';

import Aos from 'aos';
import api from '../../services/api';
import 'aos/dist/aos.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
const phoneNumberMask = [
  '(',
  /[1-9]/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

const optionsUFRG = [
  { id: 'AC', title: 'Acre' },
  { id: 'AL', title: 'Alagoas' },
  { id: 'AP', title: 'Amapá' },
  { id: 'AM', title: 'Amazonas' },
  { id: 'BA', title: 'Bahia' },
  { id: 'CE', title: 'Ceará' },
  { id: 'DF', title: 'Distrito Federal' },
  { id: 'ES', title: 'Espirito Santo' },
  { id: 'GO', title: 'Goiás' },
  { id: 'MA', title: 'Maranhão' },
  { id: 'MT', title: 'Mato Grosso' },
  { id: 'MS', title: 'Mato Grosso do Sul' },
  { id: 'MG', title: 'Minas Gerais' },
  { id: 'PA', title: 'Pará' },
  { id: 'PB', title: 'Paraíba' },
  { id: 'PR', title: 'Paraná' },
  { id: 'PE', title: 'Pernambuco' },
  { id: 'PI', title: 'Piauí' },
  { id: 'RJ', title: 'Rio de Janeiro' },
  { id: 'RN', title: 'Rio Grande do Norte' },
  { id: 'RS', title: 'Rio Grande do Sul' },
  { id: 'RO', title: 'Rondônia' },
  { id: 'RR', title: 'Roraima' },
  { id: 'SC', title: 'Santa Catarina' },
  { id: 'SP', title: 'São Paulo' },
  { id: 'SE', title: 'Sergipe' },
  { id: 'TO', title: 'Tocantins' },
];
const optionsUF = [
  { id: 'AC', title: 'Acre' },
  { id: 'AL', title: 'Alagoas' },
  { id: 'AP', title: 'Amapá' },
  { id: 'AM', title: 'Amazonas' },
  { id: 'BA', title: 'Bahia' },
  { id: 'CE', title: 'Ceará' },
  { id: 'DF', title: 'Distrito Federal' },
  { id: 'ES', title: 'Espirito Santo' },
  { id: 'GO', title: 'Goiás' },
  { id: 'MA', title: 'Maranhão' },
  { id: 'MT', title: 'Mato Grosso' },
  { id: 'MS', title: 'Mato Grosso do Sul' },
  { id: 'MG', title: 'Minas Gerais' },
  { id: 'PA', title: 'Pará' },
  { id: 'PB', title: 'Paraíba' },
  { id: 'PR', title: 'Paraná' },
  { id: 'PE', title: 'Pernambuco' },
  { id: 'PI', title: 'Piauí' },
  { id: 'RJ', title: 'Rio de Janeiro' },
  { id: 'RN', title: 'Rio Grande do Norte' },
  { id: 'RS', title: 'Rio Grande do Sul' },
  { id: 'RO', title: 'Rondônia' },
  { id: 'RR', title: 'Roraima' },
  { id: 'SC', title: 'Santa Catarina' },
  { id: 'SP', title: 'São Paulo' },
  { id: 'SE', title: 'Sergipe' },
  { id: 'TO', title: 'Tocantins' },
];

const optionsUFCRM = [
  { id: 'AC', title: 'Acre' },
  { id: 'AL', title: 'Alagoas' },
  { id: 'AP', title: 'Amapá' },
  { id: 'AM', title: 'Amazonas' },
  { id: 'BA', title: 'Bahia' },
  { id: 'CE', title: 'Ceará' },
  { id: 'DF', title: 'Distrito Federal' },
  { id: 'ES', title: 'Espirito Santo' },
  { id: 'GO', title: 'Goiás' },
  { id: 'MA', title: 'Maranhão' },
  { id: 'MT', title: 'Mato Grosso' },
  { id: 'MS', title: 'Mato Grosso do Sul' },
  { id: 'MG', title: 'Minas Gerais' },
  { id: 'PA', title: 'Pará' },
  { id: 'PB', title: 'Paraíba' },
  { id: 'PR', title: 'Paraná' },
  { id: 'PE', title: 'Pernambuco' },
  { id: 'PI', title: 'Piauí' },
  { id: 'RJ', title: 'Rio de Janeiro' },
  { id: 'RN', title: 'Rio Grande do Norte' },
  { id: 'RS', title: 'Rio Grande do Sul' },
  { id: 'RO', title: 'Rondônia' },
  { id: 'RR', title: 'Roraima' },
  { id: 'SC', title: 'Santa Catarina' },
  { id: 'SP', title: 'São Paulo' },
  { id: 'SE', title: 'Sergipe' },
  { id: 'TO', title: 'Tocantins' },
];

// const optionsperson_type = [
//   { id: 'health_professional', title: 'Médico' },
//   { id: 'employee_eurofarma', title: 'Colaborador Eurofarma' },
// ];

// const allow_emails_eurofarma = [{ email: 'eurofarma.com' }];

const optionTypeConselho = [
  { id: 'CRF', title: 'CRF' },
  { id: 'COREN', title: 'COREN' },
];

const TypeCargo = [
  { id: 'Enfermeiro', title: 'Enfermeiro' },
  { id: 'Farmacêutico', title: 'Farmacêutico' },
  { id: 'Nutricionista', title: 'Nutricionista' },
  { id: 'Psicólogo', title: 'Psicólogo' },
  { id: 'Others', title: 'Outros' },
];

const RegisterSchema = Yup.object().shape({
  name: Yup.string()
    .max(30, 'o nome deve ter 30 caracteres no máximo')
    .required('Campo necessário'),

  email: Yup.string()
    .required('E-mail é obrigatório')
    .email('Formato de endereço de e-mail inválido')
    .test(
      'isLowerCase',
      'Email deve ser todo minúsculo',
      (email) => email && email === email.toLowerCase()
    ),

  // email: Yup.string()
  //   .required('Campo necessário')
  //   .email('Formato de endereço de e-mail inválido')
  //   .test(
  //     'allowEmail',
  //     'O seu e-mail não foi encontrado no nosso banco de dados, por favor entre em contato com a equipe de eventos Eurofarma para a checagem.',
  //     (email, { parent }) => {
  //       if (email && parent.fields.person_type == 'employee_eurofarma') {
  //         const result = allow_emails_eurofarma.find(
  //           (item) => item.email === email.split('@')[1]
  //         );
  //         return result;
  //       }
  //       return true;
  //     }
  //   )
  //   .test(
  //     'isLowercase',
  //     'Use somente letras minusculas',
  //     (email) => email && email === email.toLowerCase()
  //   ),

  // password: Yup.string()
  //      .required("Senha é obrigatório")
  //      .matches( /^(?=.*[A-Za-z])(?=.*\d)[\w\W]{8,100}$/,"Digite uma senha forte. Ex: Nbb_885522")
  //      .min(8)
  //      .matches(RegExp("(.*[a-z].*)"), "Lowercase")
  //      .matches(RegExp("(.*[A-Z].*)"), "Uppercase")
  //      .matches(RegExp("(.*\\d.*)"), "Number"),

  fields: Yup.object().shape({
    lastName: Yup.string().required('Campo necessário'),
    city: Yup.string().required('Campo necessário'),
    state: Yup.string().required('Campo necessário'),
    registerNumber: Yup.string().required('Campo necessário'),
    state_crm: Yup.string().required('Campo necessário'),
    office: Yup.string().required('Campo necessário'),

    /* specialty: Yup.string().required('Campo necessário'), */
    /* company: Yup.string().required('Campo necessário'), */

    // typedoc: Yup.string().required('Campo necessário'),

    other: Yup.string().when('TypeCargo', {
      is: (value) => value === 'Others',

      then: Yup.string().required('Campo necessário'),
    }),

    // boardNumber: Yup.string().when('person_type', {
    //   is: (value) => value !== 'employee_eurofarma',
    //   then: Yup.string()
    //     .required('Campo necessário')
    //     .test('validarCrm', 'CRM invalido', async (value, { parent }) => {
    //       try {
    //         if (!value) return false;
    //         console.log(typeof value);
    //         // if (parent.typedoc !== 'CRM') return true;
    //         if (parent.person_type === 'other_professional') return true;
    //         const response = await fetch(
    //           `https://us-central1-rstcom20.cloudfunctions.net/api/doctors/validate/${value}/${parent.state_crm}`
    //         );
    //         const { valid } = await response.json();

    //         return !!valid;
    //       } catch (error) {
    //         return false;
    //       }
    //     }),
    // }),

    // boardNumber: Yup.string().when('person_type', {
    //   is: (value) => value === 'health_professional',

    //   then: Yup.string()
    //     .required('CRM necessário')
    // }),

    // state_crm: Yup.string().when('person_type', {
    //   is: (value) => value === 'health_professional',

    //   then: Yup.string()
    //     .required('Campo necessário')
    // }),

    // state: Yup.string().when('person_type', {
    //   is: (value) => value === 'health_professional',

    //   then: Yup.string()
    //     .required('Campo necessário')
    // }),

    // contact: Yup.string().when('person_type', {
    //   is: (value) => value === 'health_professional',

    //   then: Yup.string()
    //     .required('Campo necessário')

    // }),

    acceptTerms: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
    acceptData: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
    acceptRecord: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
    // acceptTermsPrivacy: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
    TermsRst: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
    // PrivacyRst: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
  }),
});

const SectionRegister = () => {
  const { inforRegister } = useContext(Context);

  const history = useHistory();
  const { eventKey } = useParams();
  const [isSubmitting, SetisSubmitting] = useState(false);

  const [initialValues, SetInitialValues] = useState({
    name: '',
    email: '',
    role: 'participante',
    fields: {
      lastName: '',

      state_crm: '',

      person_type: '',
      other: '',

      contact: '',
      registerNumber: '',
      office: '',

      acceptTerms: false,

      acceptEmail: false,
      acceptRecord: false,
      acceptData: false,
      // acceptTermsPrivacy: false,
      TermsRst: false,
      // PrivacyRst:false,

      city: '',
      state: '',
    },
    eventKey: '',
    password: 'mtm234',
  });

  const handleSubmit = async (values, actions) => {
    if (isSubmitting) return;
    SetisSubmitting(true);
    try {
      console.log('handleSubmit', values);

      await api.post('participant', values);

      // Envio do email
      const obj2 = {
        subject: '  Inscrição confirmada Meeting the Minds Libbs',
        to: 'noreply@libbs.com',
        from: 'noreply@libbs.com',
        fromname: ' Inscrição confirmada Meeting the Minds Libbs',
        urlmail: `https://4yourlive.com/${values.eventKey}/email/index.html`,
        name: values.name,
        email: values.email,
      };

      let formBody = [];

      for (const property in obj2) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(obj2[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
      }
      formBody = formBody.join('&');

      fetch('https://rstcom.live/mailgun-sendmail/index.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBody,
      }).then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
        },
        (error) => {
          console.log('FAILED...', error);
        }
      );

      toast.success(
        'Inscrição confirmada! Em breve você receberá um e-mail com instruções para acesso ao evento',
        {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      actions.resetForm();
      history.push(`/${eventKey}`);
      // window.open(`/${eventKey}/signin`, '_blank');
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Nao foi possivel realizar o cadastro, tente novamente.',
        {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    } finally {
      SetisSubmitting(false);
    }

    actions.setSubmitting(false);
  };

  function onBlurCep(ev, setFieldValue) {
    const { value } = ev.target;

    const zipcode = value;

    // if (zipcode?.length !== 8) {
    //   return;
    // }

    fetch(`https://viacep.com.br/ws/${zipcode}/json/`)
      .then((res) => res.json())
      .then((data) => {
        setFieldValue('fields[street]', data.logradouro);
        setFieldValue('fields[district]', data.bairro);
        setFieldValue('fields[city]', data.localidade);
        setFieldValue('fields[state]', data.uf);
      });
  }

  useEffect(() => {
    SetInitialValues((prev) => ({
      ...prev,
      password: inforRegister?.settings?.password,
      eventKey,
    }));
  }, [inforRegister, eventKey]);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      {inforRegister?.settings?.access?.show_signup_button && (
        <section id="section-register" className="light-mode">
          <div className="wm wm-border light" data-aos="fade-down">
            inscrição
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-6 offset-md-3 text-center">
                <h1 data-aos="fade-up">Inscreva-se</h1>
                <div className="separator">
                  <span>
                    <i className="fa fa-square" />
                  </span>
                </div>
                <div className="spacer-single" />
              </div>
              <div className="col-md-8 offset-md-2">
                <Formik
                  name="contactForm"
                  id="contact_form"
                  initialValues={initialValues}
                  enableReinitialize
                  validationSchema={RegisterSchema}
                  onSubmit={handleSubmit}
                >
                  {({ handleChange, handleBlur, values, touched, errors }) => (
                    <Form>
                      <div className="row">
                        <div className="col-md-6 mb-0">
                          <div className="">
                            <input
                              type="hidden"
                              name="eventKey"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.eventKey}
                            />
                            <input
                              type="hidden"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              type="text"
                              name="name"
                              placeholder="Nome *"
                              className={`form-control ${
                                touched.name && errors.name ? 'is-invalid' : ''
                              }`}
                            />

                            <ErrorMessage
                              component="div"
                              name="name"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              type="text"
                              name="fields[lastName]"
                              placeholder="Sobrenome *"
                              className={`form-control ${
                                touched?.fields?.lastName &&
                                errors?.fields?.lastName
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[lastName]"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              type="text"
                              name="email"
                              placeholder="Email *"
                              className={`form-control ${
                                touched.email && errors.email
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="email"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              type="text"
                              name="fields[city]"
                              placeholder="Cidade *"
                              className={`form-control ${
                                touched?.fields?.city && errors?.fields?.city
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[city]"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              name="fields[state]"
                              component="select"
                              className={` form-control ${
                                touched?.fields?.state && errors?.fields?.state
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">UF *</option>
                              {optionsUF.map((option) => (
                                <option value={option.id} key={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              component="div"
                              name="fields[state]"
                              className="invalid-feedback"
                            />
                          </div>

                          {/* <div className="form-group">
                              <Field
                                name="fields[state_crm]"
                                component="select"
                                className={` form-control ${
                                  touched?.fields?.state_crm &&
                                  errors?.fields?.state_crm
                                    ? 'is-invalid'
                                    : ''
                                }`}
                              >
                                <option value="">COREN OU CRF*</option>
                                {optionsUFCRM.map((option) => (
                                  <option value={option.id} key={option.id}>
                                    {option.title}
                                  </option>
                                ))}
                              </Field>

                              <ErrorMessage
                                component="div"
                                name="fields[state_crm]"
                                className="invalid-feedback"
                              />
                            </div> */}
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <Field
                              name="fields[state_crm]"
                              component="select"
                              className={` form-control ${
                                touched?.fields?.state_crm &&
                                errors?.fields?.state_crm
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">Registro Profissional*</option>
                              {optionTypeConselho.map((option) => (
                                <option value={option.id} key={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              component="div"
                              name="fields[state_crm]"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              type="number"
                              name="fields[registerNumber]"
                              placeholder="N de Registro *"
                              className={`form-control ${
                                touched?.fields?.registerNumber &&
                                errors?.fields?.registerNumber
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[registerNumber]"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="form-group">
                            <Field
                              name="fields[office]"
                              component="select"
                              className={`form-control ${
                                touched?.fields?.office &&
                                errors?.fields?.office
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">Cargo que atua:*</option>
                              {TypeCargo.map((option) => (
                                <option value={option.id} key={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>
                            <ErrorMessage
                              component="div"
                              name="fields[office]"
                              className="invalid-feedback"
                            />
                          </div>

                          {Boolean(
                            values.fields.office &&
                              values.fields.office === 'Others'
                          ) && (
                            <div className="form-group">
                              <Field
                                type="text"
                                name="fields[other]"
                                placeholder="Qual ? *"
                                className={`form-control ${
                                  touched?.fields?.other &&
                                  errors?.fields?.other
                                    ? 'is-invalid'
                                    : ''
                                }`}
                              />
                              <ErrorMessage
                                component="div"
                                name="fields[other]"
                                className="invalid-feedback"
                              />
                            </div>
                          )}

                          <div className="form-group">
                            <Field
                              type="text"
                              name="fields[PlaceYouWork]"
                              placeholder="Instituição que trabalha *"
                              className={`form-control ${
                                touched?.fields?.PlaceYouWork &&
                                errors?.fields?.PlaceYouWork
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[PlaceYouWork]"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[acceptData]"
                          id="acceptData"
                          className={`form-check-input ${
                            errors?.fields?.acceptData &&
                            touched?.fields?.acceptData
                              ? ' is-invalid'
                              : ''
                          }`}
                        />

                        <label
                          htmlFor="acceptData"
                          className="form-check-label"
                        >
                          Afirmo que sou profissional de saúde habilitado e as
                          informações preenchidas são verdadeiras.
                        </label>
                        <ErrorMessage
                          name="fields[acceptData]"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[acceptRecord]"
                          id="acceptRecord"
                          className={`form-check-input ${
                            errors?.fields?.acceptRecord &&
                            touched?.fields?.acceptRecord
                              ? ' is-invalid'
                              : ''
                          }`}
                        />

                        <label
                          htmlFor="acceptRecord"
                          className="form-check-label"
                        >
                          Asseguro que essa reunião virtual não será gravada de
                          forma alguma ou seu link direcionado à terceiros, uma
                          vez que se trata de uma reunião exclusiva para
                          convidados.
                        </label>
                        <ErrorMessage
                          name="fields[acceptRecord]"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      {/* <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[acceptTerms]"
                          id="acceptTerms"
                          className={`form-check-input ${
                            errors?.fields?.acceptTerms &&
                            touched?.fields?.acceptTerms
                              ? ' is-invalid'
                              : ''
                          }`}
                        />
                        <label
                          htmlFor="acceptTerms"
                          className="form-check-label"
                        >
                          Declaro que li e concordo com os {' '}
                          <a
                            href="https://4yourlive.com/mtm/terms-of-use"
                            target="_blank"
                            className="termos"
                          >
                            Termos e Condições de Uso
                          </a>
                          e
                        </label>

                         <label
                          htmlFor="acceptTerms"
                          className="form-check-label"
                        >
                          <a
                            href="https://www.tratedavida.com.br/politica-de-privacidade/"
                            target="_blank"
                            className="termos"
                          >
                            Politica e Privacidade
                          </a>
                           Libbs.
                        </label>
                      </div> */}

                      {/* <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[TermsRst]"
                          id="TermsRst"
                          className={`form-check-input ${
                            errors?.fields?.TermsRst &&
                            touched?.fields?.TermsRst
                              ? ' is-invalid'
                              : ''
                          }`}
                        />
                        <label
                          htmlFor="TermsRst"
                          className="form-check-label"
                        >
                          Declaro que li e concordo com os {' '}
                          <a
                            href="https://4yourlive.com/mtm/terms-of-use"
                            target="_blank"
                            className="termos"
                          >
                            Termos e Condições de Uso
                          </a>
                          e
                        </label>

                         <label
                          htmlFor="TermsRst"
                          className="form-check-label"
                        >
                          <a
                            href=" https://4yourlive.com/mtm/privacy-and-policy"
                            target="_blank"
                            className="termos"
                          >
                            Politica e Privacidade
                          </a>
                        </label>
                      </div> */}

                      <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[TermsRst]"
                          id="TermsRst"
                          className={`form-check-input ${
                            errors?.fields?.TermsRst &&
                            touched?.fields?.TermsRst
                              ? ' is-invalid'
                              : ''
                          }`}
                        />
                        <label htmlFor="TermsRst" className="form-check-label">
                          Declaro que li e concordo com os{' '}
                          <a
                            href="https://4yourlive.com/mtm/terms-of-use"
                            target="_blank"
                            className="termos"
                          >
                            Termos e Condições de Uso.
                          </a>
                        </label>
                      </div>

                      <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[acceptTerms]"
                          id="acceptTerms"
                          className={`form-check-input ${
                            errors?.fields?.acceptTerms &&
                            touched?.fields?.acceptTerms
                              ? ' is-invalid'
                              : ''
                          }`}
                        />

                        <label
                          htmlFor="acceptTerms"
                          className="form-check-label"
                        >
                          Declaro que li e concordo com os{' '}
                          <a
                            href=" https://4yourlive.com/mtm/privacy-and-policy"
                            target="_blank"
                            className="termos"
                          >
                            Politica e Privacidade.
                          </a>
                        </label>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-12 text-center">
                          <button
                            type="submit"
                            className="btn btn-line btn_register"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Cadastrando..' : 'Inscrever-se'}
                          </button>
                        </div>

                        {inforRegister?.settings?.access
                          ?.show_subscribed_button && (
                          <a
                            href={`/${eventKey}/signin`}
                            target="_blank"
                            className="inscrito"
                          >
                            Já sou inscrito / Acesse o evento
                          </a>
                        )}

                        <ToastContainer />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default SectionRegister;
